/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DistrictResponseDto } from './districtResponseDto';
import { MemberTierResponseDto } from './memberTierResponseDto';
import { ProvinceResponseDto } from './provinceResponseDto';
import { SubDistrictResponseDto } from './subDistrictResponseDto';

export interface MemberResponseDto {
  createdUserId: string;
  createdUsername: string;
  createdAt: Date;
  updatedUserId: string;
  updatedUsername: string;
  updatedAt: Date;
  deletedUserId: string;
  deletedUsername: string;
  deletedAt: Date;
  id: string;
  name: string;
  firstname: string;
  lastname: string;
  entityType: MemberResponseDto.EntityTypeEnum;
  cid: string;
  address: string;
  province: ProvinceResponseDto;
  district: DistrictResponseDto;
  subDistrict: SubDistrictResponseDto;
  zipCode: string;
  email: string;
  imageUrl: string;
  documentImageUrl: string;
  signatureImageUrl: string;
  phone: string;
  memberTier: MemberTierResponseDto;
  isActive: boolean;
  memberNo: string;
  noOfBank: number;
}
// tslint:disable-next-line:no-namespace
export namespace MemberResponseDto {
  export type EntityTypeEnum = 'individual' | 'corporate';
  export const EntityTypeEnum = {
      Individual: 'individual' as EntityTypeEnum,
      Corporate: 'corporate' as EntityTypeEnum,
  };
}
